<div class="graphic-list-container">
  <ag-grid-angular
    #agGrid
    class="ag-theme-alpine full-height"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (filterChanged)="onFilterChanged($event)"
    (rowClicked)="onRowClicked($event)"
  >
  </ag-grid-angular>

  <!-- action section -->
  <div class="filter-controllers">
    <!-- reset filter -->
    <button
      *ngIf="!hideClearFiltersButton"
      class="clear-filters"
      mat-flat-button
      color="accent"
      [disabled]="isDefaultFilters$ | async"
      (click)="clearAllFilters()"
    >
      <mat-icon>filter_alt_off</mat-icon>
      {{ 'COMMON.clearFilters' | translate }}
    </button>

    <!-- csv export -->
    <ag-grid-csv-export-button class="csv-button" [tabLayer]="tabID" [agGrid]="agGrid"> </ag-grid-csv-export-button>

    <!-- just map extent filter -->
    <mat-checkbox [checked]="justMapExtent$ | async" (change)="toggleJustMine($event.checked)">
      {{ 'COMMON.justMapExtent' | translate }}
    </mat-checkbox>
  </div>
</div>
